import React from "react";
import { Todo } from "./Todo";
import { TodoForm } from "./TodoForm";
import { EditForm } from "./EditForm";
import { v4 as uuidv4 } from "uuid";
import cart1 from '../assets/supermarket-shelf.png';

export const TodoWrapper = ({ todos, setTodos }) => {
  const addTodo = (todo) => {
    if (todo.trim() === "") {
      alert("Don't leave me hanging! Please add an item to your shopping list!");
      return; 
    }
    
    setTodos([
      ...todos,
      { id: uuidv4(), task: todo, completed: false, isEditing: false },
    ]);
  };

  const deleteTodo = (id) => setTodos(todos.filter((todo) => todo.id !== id));

  const toggleComplete = (id) => {
    setTodos(
      todos.map((todo) =>
        todo.id === id ? { ...todo, completed: !todo.completed } : todo
      )
    );
  };

  const editTodo = (id) => {
    setTodos(
      todos.map((todo) =>
        todo.id === id ? { ...todo, isEditing: !todo.isEditing } : todo
      )
    );
  };

  const editTask = (task, id) => {
    setTodos(
      todos.map((todo) =>
        todo.id === id ? { ...todo, task, isEditing: !todo.isEditing } : todo
      )
    );
  };

  const clearAll = () => {
    if (window.confirm("Are you sure you want to clear all items?")) {
      setTodos([]);
    }
  };
  

  return (
    <div className="TodoWrapper">
      <img src={cart1} className="cart" alt="empty cart" />
      <h1>What would you like to buy?</h1>
      <TodoForm addTodo={addTodo} />
      
      {todos.map((todo) =>
        todo.isEditing ? (
          <EditForm key={todo.id} editTodo={editTask} task={todo} />
        ) : (
          <Todo
            key={todo.id}
            task={todo}
            deleteTodo={deleteTodo}
            editTodo={editTodo}
            toggleComplete={toggleComplete}
          />
        )
      )}

      {todos.length > 0 && <button className="clear-btn" onClick={clearAll}>Clear All</button>}
    </div>
  );
};
